import { render, staticRenderFns } from "./StaffShiftEditDialog.vue?vue&type=template&id=61f461b3&scoped=true&"
import script from "./StaffShiftEditDialog.vue?vue&type=script&lang=ts&"
export * from "./StaffShiftEditDialog.vue?vue&type=script&lang=ts&"
import style0 from "./StaffShiftEditDialog.vue?vue&type=style&index=0&id=61f461b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f461b3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VInput } from 'vuetify/lib/components/VInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCheckbox,VForm,VInput,VRow,VSheet,VSpacer})
